<script lang="ts">
	import { Alert, Button, Text } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';
	import { push } from 'svelte-spa-router';
	import { format } from 'svelte-i18n';
	import { setSidePanelState } from 'src/components/Sidepanel/sidepanel-helpers';
	export let showAboutAIModelModal = false,
		device;

	const goToPremiumSettings = () => {
		push('/settings/premium');

		setSidePanelState({
			type: undefined,
			id: device.id,
			open: false, // doesn't close the device drawer
		});
	};
</script>

<Alert
	type="warning"
	customIcon="fas fa-gem text-warning"
	heading={$format('title_upgrade_to_premium_for_ai', {
		default: 'Upgrade to Premium for advanced AI monitoring!',
	})}
	subHeading={$format('text_upgrade_to_premium_for_ai', {
		default:
			'Detect issues early, get automated notifications, and ensure top performance for your device.',
	})}
	isHeadingBold
>
	<div slot="bottom">
		<div class="d-flex align-items-center">
			<Button variant="premium" size="m" width="auto" on:click={goToPremiumSettings}>
				{capFirstChar(
					$format('button_get_premium', {
						default: 'Get Premium',
					}),
				)}
			</Button>
			<Text
				styleType="body-small"
				class="text-decoration-underline cursor-pointer ml-s text-primary"
				on:click={() => {
					showAboutAIModelModal = true;
				}}
			>
				{$format('about_ai_model', { default: 'About AI Model' })}
			</Text>
		</div>
	</div>
</Alert>
